import { Component, OnDestroy, OnInit} from '@angular/core';

import {EditModalService} from '../../services/edit-modal.service';
import {ModalVisibilityService} from '../../services/modal-visibility.service';
import {Subscription} from 'rxjs';
import {ModalDialog} from '@brother-apps/brother-dealerapp-shared-lib';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-item-label-info-modal',
    templateUrl: './item-label-info-modal.component.html',
    styleUrls: ['./item-label-info-modal.component.scss']
})
export class ItemLabelInfoModalComponent extends ModalDialogV3 implements OnInit, OnDestroy {

    private modalVisibilitySub: Subscription;
    public isImageLoading = true;
    public isLoadingError = false;

    public model: { title: string, imageUrl: string, top: string, left: string };

    constructor(public editModalService: EditModalService,
                private modalVisibilityService: ModalVisibilityService
    ) {
        super();
    }

    ngOnInit() {
        this.model = <{ title: string, imageUrl: string, top: string, left: string }>this.modalParams.model;
        this.modalVisibilitySub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(_ => {
            super.close();
        });
    }

    public onImageLoad() {
        this.isImageLoading = false;
    }


    onImageError() {
        this.isImageLoading = false;
        this.isLoadingError = true;
    }

    ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }

}
